import { FilterableField } from 'module/types/filter-field/field/filterable-field';
import { currency_fields } from 'helpers/fields/company-fields/category';
import { CompanyFields } from 'helpers/fields/company-fields/fields';
import {
  RecentRisksCell,
  RecentOpportunitiesCell,
  RecentOperationalSignalsCell,
} from 'components/organisms/accounts/lists/gridconfig/cell-renderer';
import { getRenderer as getRendererBase } from '../../ag-grid-renderer/ag-grid-renderer';

export const getRenderer = (field: FilterableField) => {
  if (currency_fields.includes(field.fieldName)) {
    return 'CurrencyRenderer';
  }

  switch (field.fieldName) {
    case CompanyFields.companyName:
      return 'AvatarAndNameRender';
    case CompanyFields.lastActivityDate:
      return 'LastActivityRenderer';
    case CompanyFields.trackedHours:
    case CompanyFields.totalAllocatedHours:
    case CompanyFields.billableHours:
      return 'HoursMinutesRenderer';
    case CompanyFields.actualProfitMargin:
    case CompanyFields.estimatedProfitMargin:
      return 'PercentageRenderer';
    case CompanyFields.overAllProjectRating:
    case CompanyFields.lastMilestoneCSAT:
      return 'CsatRatingRenderer';
    case CompanyFields.recentRiskSignals:
      return RecentRisksCell;
    case CompanyFields.recentOpportunitySignals:
      return RecentOpportunitiesCell;
    case CompanyFields.recentOperationalSignals:
      return RecentOperationalSignalsCell;
    default:
      return getRendererBase(field);
  }
};
